export default {
  'zh-CN': {
    to: '至',
    startDate: '开始日期',
    endDate: '结束日期',
    endMoreStart: '结束时间不能小于开始时间'
  },
  'en': {
    to: 'To',
    startDate: 'Start date',
    endDate: 'End date',
    endMoreStart: '结束时间不能小于开始时间'
  },
  'ja': {
    to: 'に',
    startDate: '開始日',
    endDate: '終了日',
    endMoreStart: '終了時間は開始時間より短くすることはできません'
  }
}
